import React from "react";
import ReactDOM from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/**
 * Dev preview: run the real dashboard against a fake cts_api with no Auth0
 * tenant, for looking at the UI locally. See `src/devPreview/index.tsx`.
 *
 * NODE_ENV is the load-bearing half of this condition, not the env var.
 * `.env` is TRACKED in this repo and every REACT_APP_* value is inlined into the
 * bundle, so "nobody will set REACT_APP_DEV_PREVIEW in a committed file" is not
 * a guarantee worth relying on -- and `react-scripts build` pins
 * NODE_ENV=production where a .env file cannot override it. CRA substitutes
 * `process.env.NODE_ENV` literally, so in a production build this whole branch
 * is statically false, the `require` is never reached, and the preview and its
 * fixtures are not in the bundle at all.
 */
if (
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_DEV_PREVIEW === "1"
) {
  // require(), not a top-level import, AND the condition written inline: both
  // are load-bearing. CRA's DefinePlugin substitutes these two reads literally,
  // so webpack sees `if (false && ...)`, drops the branch, and never adds the
  // preview to the module graph. Hoisting the condition into a `const` defeats
  // that -- webpack folds `if (<literal>)`, not `if (<variable>)` -- and the
  // fixtures and the fake Auth0 context end up in the production bundle. They
  // did, until a grep of build/static/js said so.
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const DevPreview = require("./devPreview").default;
  ReactDOM.render(<DevPreview />, document.getElementById("root"));
} else {
  ReactDOM.render(
    <Auth0Provider
      domain="cooktopsafety.us.auth0.com"
      clientId="uQE1Hg4askKM0sqF6VniqjZzdROgphIk"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://api.cooktopsafety.com",
        scope: "offline_access openid email",
      }}
    >
      <App />
    </Auth0Provider>,
    document.getElementById("root")
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
